import {useRef,useState} from "react";
import {GuideAudioPlayer} from "./GuideAudioPlayer";
import {SystemIcon} from "./SystemIcon";

export type GuideMenuItem={label:string;href:string};

export function GuideMenu({items}:{items:ReadonlyArray<GuideMenuItem>}){
  const [selected,setSelected]=useState<GuideMenuItem|null>(null);
  const details=useRef<HTMLDetailsElement>(null);
  return <><details className="guide-menu" ref={details}>
    <summary><SystemIcon name="document"/><span>Guida</span></summary>
    <nav className="guide-menu-popover" aria-label="Guide audio">
      <strong>Guide audio</strong>
      <ol>{items.map(item=><li key={item.href}><button type="button" onClick={()=>{setSelected(item);if(details.current)details.current.open=false;}}>{item.label}</button></li>)}</ol>
    </nav>
  </details>{selected?<GuideAudioPlayer title={selected.label} src={selected.href} onClose={()=>setSelected(null)}/>:null}</>;
}
